module.exports = __webpack_public_path__ + "img/finished.305e00aa.png";